import { ref } from "@vue/composition-api";
import _axios from "@/axios";

export function useTestPassweb() {
  let passwebData = ref([]);

  function testPassweb(passweb) {
    if (passweb != undefined && passweb != null && passweb != "") {
      return _axios
        .get("/client-portal-test-passweb/" + passweb)
        .then((response) => {
          passwebData.value = response.data.data;
        })
        .catch(() => {
          alert(
            "Une erreur est survenue, si cela se reproduit contactez le support"
          );
        });
    }
  }

  return {
    testPassweb,
    passwebData,
  };
}
